import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TranslationState {
  isTranslationEnabled: boolean;
  setTranslationEnabled: (enabled: boolean) => void;
  toggleTranslation: () => void;
}

export const useTranslationStore = create<TranslationState>()(
  persist(
    (set) => ({
      isTranslationEnabled: true,
      setTranslationEnabled: (enabled) => set({ isTranslationEnabled: enabled }),
      toggleTranslation: () => set((state) => ({ isTranslationEnabled: !state.isTranslationEnabled })),
    }),
    {
      name: 'jema-translation-preferences',
    }
  )
);
